// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"62806915","453":"e0069f0e","455":"a11e3e2c","977":"79e5d9ea"}[chunkId] + ".chunk.js";
};